import { FC, useContext } from 'react';
import { INormalizedTeamForm } from '../../../../../../packages/types/common';
import { ConfigContext, TeamForm } from '@velinsi/smp-widgets-ui';

interface Props {
  data: INormalizedTeamForm[];
  handleClick: (id: string | number) => void;
}
const FormResults: FC<Props> = ({ data, handleClick }) => {
  const { dataTheme, dataLabels } = useContext(ConfigContext);

  if (!data || !data.length) return null;

  return (
    <div className='form-container flex gap-1'>
      {data.map((element) => (
        <TeamForm
          key={element.matchId}
          dataTheme={dataTheme === 'dark' ? 'dark' : 'light'}
          dataLabels={dataLabels}
          form={element}
          handleEventClick={handleClick}
        />
      ))}
    </div>
  );
};

export default FormResults;
